export default "__VITE_ASSET__BYDDU4Qm__"